import { trackEvent } from '@/analytics'
import { EVENT_ACTION, EVENT_CATEGORY, EVENT_NAME } from '@/constants/analytics'
import { mapActions } from 'vuex'
import DragAndDropMixin from '@/mixins/DragAndDropMixin'

/**
 * This is the mixin for drag and drop support of ideas
 */
export default {
  data() {
    return {
      ideasContainerKey: 0
    }
  },
  mixins: [DragAndDropMixin],
  methods: {
    ...mapActions(['changeRank']),
    enableIdeaDragAndDrop() {
      this.enableDragAndDrop({
        containers: [this.$refs.ideas],
        onDrop: this.onDrop,
        onDragEnd: this.onDragEnd
      })
    },
    async onDrop({ afterId, beforeId, subjectId }) {
      const ideas = this.ideas
      try {
        await this.changeRank({
          orgId: this.ideaList.organizationId,
          type: 'idea',
          subjectId,
          beforeId,
          afterId
        })
        const newIdeas = this.shiftItem(ideas, subjectId, beforeId)
        this.updateIdeas(newIdeas)
        this.$emit('update-ideas', newIdeas)
        trackEvent(EVENT_CATEGORY.ACTIVITY, EVENT_ACTION.REARRANGE, EVENT_NAME.IDEA)
      } catch (e) {
        // Revert the drag. Re-rendering the list
        this.ideasContainerKey++
        this.$nextTick(function() {
          // This should be inside nextTick because drag and drop should be re-enabled after list is rendered
          this.enableIdeaDragAndDrop()
        })
      }
    },
    onDragEnd() {
      // select the list item tab-pin, so that on tab, status checkbox is selectable
      this.focusTabPin()
    }
  }
}
